import { generateUtilityClass, generateUtilityClasses } from '@mui/material';
import { projectPrefix } from '../constants';

export const statusClasses = generateUtilityClasses(
  `${projectPrefix}Status`,
  [
    'root',
    'sm',
    'md',
    'lg',
    'xl',
    'available',
    'idle',
    'dnd',
    'offline',
    'unknown',
  ],
);

export const getStatusUtilityClass = (slot: string) => generateUtilityClass(`${projectPrefix}Status`, slot);
